import { Box, TextField, Avatar} from '@mui/material'
import { ValidateInt } from '../../../../../../../../../../core/validator/Validator';

export const Style = ({inputs, handlerChange, prodTemplate}) => {
    const q = new URLSearchParams(window.location.search);
    const handlerFileUpload = (e) => {
        const state = {...prodTemplate.data.inputs}
        const {name, files} = e.target
        const upld_file = files[0]
        state[name] = {value: upld_file, object: URL.createObjectURL(upld_file), stat: false, msg: '', type: upld_file.type.split('/')[0], }
        prodTemplate.set({...prodTemplate.data, inputs: state})
    }
    
    return (
        <Box p={2} display="flex" flexDirection="column" gap="8px" height="100%" width="100%">
            <>
                <Box display="flex" fontWeight={600}>Background Photo<Box color="#FA3E3E">*</Box></Box>
                <img src={inputs.bg.object} alt="background_photo" width="100%" style={{minHeight: 140, objectFit: 'cover'}} />
                {
                    q.get('id') !== null ? 
                        null
                    :
                        inputs.bg.type === 'default' &&
                            <Box fontSize={14} color="red" textAlign="center">Change the default Background Photo</Box>
                }
            </>
            <Box display="flex" justifyContent="center">
                <Box component="label" htmlFor='bg' className="c-pointer" bgcolor="#009E6A" sx={{transition: 'ease-in-out'}} p="4px" borderRadius="8px" color="#fff">
                    Change
                </Box>
                <input type="file" accept="image/*" id="bg" name="bg" hidden onChange={(e) => handlerFileUpload(e)}  />
            </Box>
            <Box display="flex" fontWeight={600}>Logo<Box color="#FA3E3E">*</Box></Box>
            <Box display="flex" justifyContent="center">
                <Avatar variant='rounded' src={inputs.logo.object} />
            </Box>
            {
                q.get('id') !== null ? 
                    null
                :
                inputs.logo.type === 'default' &&
                    <Box fontSize={14} color="red" textAlign="center">Change the default logo</Box>
            }
            <Box display="flex" justifyContent="center">
                <Box component="label" htmlFor='logo' className="c-pointer" bgcolor="#009E6A" p="4px" borderRadius="8px" color="#fff">
                    Change
                </Box>
                <input type="file" accept="image/*" id="logo" name="logo" hidden onChange={(e) => handlerFileUpload(e)} />
            </Box>
            <>
                <Box display="flex" fontWeight={600}>Featured Image<Box color="#FA3E3E">*</Box></Box>
                <img src={inputs.ft_img.object} alt="ft_img_photo" width="100%" style={{minHeight: 140, objectFit: 'cover'}} />
                {
                    q.get('id') !== null ? 
                        null
                    :
                        inputs.ft_img.type === 'default' &&
                            <Box fontSize={14} color="red" textAlign="center">Change the default Featured Image</Box>
                }
            </>
            <Box display="flex" justifyContent="center">
                <Box component="label" htmlFor='ft_img' className="c-pointer" bgcolor="#009E6A" p="4px" borderRadius="8px" color="#fff">
                    Change
                </Box>
                <input type="file" accept="image/*" id="ft_img" name="ft_img" hidden onChange={(e) => handlerFileUpload(e)} />
            </Box>
            <>
                <Box fontWeight={600}>Price background color</Box>
                <TextField size="small" name="price_bg" value={inputs.price_bg.value} type='color' sx={{width: 50 }} onChange={(e) => handlerChange(e)} />
            </>
            <>
                <Box fontWeight={600}>Button caption</Box>
                <TextField size="small" name="button_caption" value={inputs.button_caption.value} onChange={(e) => handlerChange(e)} />
            </>
            <>
                <Box fontWeight={600}>Contact No.</Box>
                <TextField size="small" name="contact_num" value={inputs.contact_num.value} onChange={(e) => handlerChange(e)} onKeyPress={ValidateInt} />
            </>
            <>
                <Box display="flex" fontWeight={600}>Facebook<Box color="#FA3E3E">*</Box></Box>
                <TextField size="small" name="facebook" onChange={(e) => handlerChange(e)} 
                    value={inputs.facebook.value} error={inputs.facebook.stat} helperText={inputs.facebook.msg}
                />
            </>
            <>
                <Box display="flex" fontWeight={600}>Instagram<Box color="#FA3E3E">*</Box></Box>
                <TextField size="small" name="instagram" onChange={(e) => handlerChange(e)} 
                    value={inputs.instagram.value} error={inputs.instagram.stat} helperText={inputs.instagram.msg}
                />
            </>
            <>
                <Box fontWeight={600}>Website</Box>
                <TextField size="small" name="website" value={inputs.website.value} onChange={(e) => handlerChange(e)} 
                    inputProps={{ maxLength: 50 }}
                />
            </>
            <Box minHeight={50} />
        </Box>
    )
}
